import { render, staticRenderFns } from "./CreateExamModal.vue?vue&type=template&id=a45e4a98&scoped=true&"
import script from "./CreateExamModal.vue?vue&type=script&lang=js&"
export * from "./CreateExamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45e4a98",
  null
  
)

export default component.exports